export function useSentry() {
  const setTag = (key, value) => window.sentry?.setTag(key, String(value));
  const setUser = (userData) => window.sentry?.setUser(userData);
  const captureException = (error, context) => window.sentry?.captureException(error, {
    extra: context,
  });

  return { setTag, setUser, captureException };
}
